/**
 * Retrieves the list of notifications.
 * @returns {Array<Object>} An array of notification objects.
 */
export function getNotifications() {
    return notifications;
}

/**
 * Array of notification objects.
 * Each notification contains an id, title, and message.
 * @type {Array<Object>}
 */
const notifications = [
    {
        /** Unique identifier for the notification */
        id: 1,
        /** Title of the notification */
        title: 'Deposits News',
        /** Detailed message of the notification */
        message:
            'Dear client, we inform you about the following changes: beginning from September 24, 2018 all transactions (incoming and out...',
    },
    {
        /** Unique identifier for the notification */
        id: 2,
        /** Title of the notification */
        title: 'Search Improved',
        /** Detailed message of the notification */
        message:
            'Dear client! Following the latest updates of the SeekMeEverywhere engines, your search has become more reliable and convenient! No...',
    },
    {
        /** Unique identifier for the notification */
        id: 3,
        /** Title of the notification */
        title: 'Transaction Reports',
        /** Detailed message of the notification */
        message:
            'Dear client, we inform you about a change in the date of monthly transaction reports. Beginning from September 20, 2018 reports...',
    },
];

// FILE DOCUMENTED
